import { functions } from '@/functions';

export const functions_sm = {
    mixins: [functions],
    data: function () {
        return {
            func: null,
            funcs:[],
            operation: null,
            state:null,
            states: [],
            condition:null,
            conditions:[],
        };
    },
    computed: {

    },
    methods: {
        loadCondition: function (onSuccess=null, param=null) {
            this.httpPrepare();
            this.$http.get(this.apiurl('sm/condition/'+this.condition_id)).then(function (response) {
                response = this.httpSuccess(response);
                this.condition = response.payload;
                this.executeFunction(onSuccess, param);
            }, this.httpError)
        },
        loadConditions: function (onSuccess=null, param=null) {
            this.httpPrepare();
            this.$http.get(this.apiurl('sm/conditions')).then(function (response) {
                response = this.httpSuccess(response);
                this.conditions = response.payload;
                this.executeFunction(onSuccess, param);
            }, this.httpError)
        },
        loadFunc: function (onSuccess=null, param=null) {
            this.httpPrepare();
            this.$http.get(this.apiurl('sm/func/'+this.func_id)).then(function (response) {
                response = this.httpSuccess(response);
                this.func = response.payload;
                this.executeFunction(onSuccess, param);
            }, this.httpError)
        },
        loadFuncs: function (onSuccess=null, param=null) {
            this.httpPrepare();
            this.$http.get(this.apiurl('sm/funcs')).then(function (response) {
                response = this.httpSuccess(response);
                this.funcs = response.payload;
                this.executeFunction(onSuccess, param);
            }, this.httpError)
        },
        loadOperation: function (onSuccess=null, param=null) {
            this.httpPrepare();
            this.$http.get(this.apiurl('sm/operation/'+this.operation_id)).then(function (response) {
                response = this.httpSuccess(response);
                this.operation = response.payload;
                this.executeFunction(onSuccess, param);
            }, this.httpError)
        },
        loadState: function (onSuccess=null, param=null) {
            this.httpPrepare();
            this.$http.get(this.apiurl('sm/state/'+this.state_id)).then(function (response) {
                response = this.httpSuccess(response);
                this.state = response.payload;
                this.executeFunction(onSuccess, param);
            }, this.httpError)
        },
        loadStates: function (onSuccess=null, param=null) {
            this.httpPrepare();
            this.$http.get(this.apiurl('sm/states')).then(function (response) {
                response = this.httpSuccess(response);
                this.states = response.payload;
                this.executeFunction(onSuccess, param);
            }, this.httpError)
        },
    },
}
